export const ANALYTICS_METRIC_TYPES = ['count', 'sum', 'avg', 'min', 'max'];
export const ANALYTICS_GROUP_BY_TYPES = ['month', 'week', 'day', 'year', 'quarter'];
//# sourceMappingURL=analytics.type.js.map